import {Component, EventEmitter, Input, Output} from '@angular/core';
import {IconFont} from "../../enums/icon-font";
import {ItemTagColor} from "./item-tag-color";
import {ItemTag} from "../../interfaces/item-tag";

@Component({
  selector: 'brt-item-tag',
  templateUrl: './item-tag.component.html',
  styleUrls: ['./item-tag.component.scss']
})
export class ItemTagComponent {

  @Output('itemClicked') itemClicked = new EventEmitter<void>();
  @Output('beforeIconClicked') beforeIconClicked = new EventEmitter<void>();
  @Output('afterIconClicked') afterIconClicked = new EventEmitter<void>();
  @Input('before-icon') beforeIcon!: IconFont;
  @Input('after-icon') afterIcon!: IconFont;
  @Input('title') title = "";
  @Input('color') color: ItemTagColor = "white";
  @Input('clickable') clickable = true;

  @Input('data') data?: ItemTag;

}
